import React from 'react'

const HolidayDeals = () => {
  return (
    <div>HolidayDeals</div>
  )
}

export default HolidayDeals